export default {
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  bgColor: 'white',
  border: true,
  borderWidth: '1',
  padding: '2',
  fontSize: '3',
  showOriginDestinationImage: false,
  separatorJourneyTypeProps: {
    content: '|',
  },
  showJourneyType: true,
  fareItemJourneyType: {},
  showTravelClass: true,
  fareItemTravelClass: {},
  fareItemOriginDestination: {
    showOriginAirportCode: false,
    showDestinationAirportCode: false,
    showSeparator: true,
    fontWeight: 'bold',
    fontSize: '4',
    textTransform: 'uppercase',
    style: {
      lineHeight: '1',
    },
  },
  showRoute: true,
  fareItemRoute: {
    fontWeight: 'bold',
    fontSize: '4',
    textColor: 'black',
    marginBottom: '2',
    separatorLabel: {
      content: 'minus',
    },
  },
  showDepartureInfo: true,
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: true,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  fareBodyItem: {
    grow: '2',
    textColor: 'dark',
    justifyContent: 'between',
  },
  fareFooterItem: {
    justifyContent: 'end',
    alignItems: 'end',
    grow: '1',
    textColor: 'dark',
  },
  showPrice: true,
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    fontWeight: 'bold',
    textAlign: 'right',
    paddingBottom: '3',
    pricePromoStyles: {
      fontWeight: 'bold',
      fontSize: '3',
    },
    currencyStyles: {
      fontSize: '5',
      textColor: 'black',
    },
  },
  showLastSeen: true,
  fareItemLastSeen: {
    shadow: '@theme:card.shadow',
    rounded: '@theme:badge.rounded',
    fontName: '@theme:card.fontName',
    border: true,
    padding: '1',
    labelStyles: {
      fontWeight: 'bold',
    },
  },
};
